/// This file was generated DO NOT MODIFY
/// Source: CurrencyRateOperation.cs
/// Tool: http://frhagn.github.io/Typewriter/pages/documentation.html

export enum CurrencyRateOperationEnum {
  Multiplication = 'Multiplication', //0
  Division = 'Division', //1
  
}
